// Simple notify helper that dispatches a custom event consumed by the Toast component
export default function notify(message, type = 'info', duration = 4000) {
  try {
    window.dispatchEvent(new CustomEvent('footy-notify', { detail: { message, type, duration } }));
  } catch (e) {
    // fallback to alert if dispatch fails
    try { alert(message); } catch {}
  }
}
